// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Accellor AI Skill Assessment — Reports theme
   Matches the main assessment landing page (logo/hero) design system.
   ========================================================================== */

:root {
  --accellor-navy: #14141f;
  --accellor-teal: #2dd4bf;
  --accellor-teal-dark: #14b8a6;
  --accellor-purple-start: #4b4f9e;
  --accellor-purple-end: #6d8fd8;
  --accellor-cyan-start: #4fc3d9;
  --accellor-green-start: #34b389;
  --accellor-red-start: #e0446b;

  --text-primary: #14141f;
  --text-secondary: #6b7280;
  --border-light: #e5e7eb;
  --bg-page: #ffffff;
  --bg-subtle: #f8f9fb;

  --radius-md: 10px;
  --radius-lg: 16px;
  --radius-pill: 999px;
  --shadow-card: 0 4px 14px rgba(20, 20, 31, 0.06);
  --shadow-hover: 0 8px 20px rgba(20, 20, 31, 0.1);
}

/* ==========================================================================
   Page wrapper — generous outer padding so content never touches the
   browser/sidebar edge.
   ========================================================================== */

.reports-page-wrapper {
  padding: 40px 48px;
  max-width: 1480px;
  margin: 0 auto;
  font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif;
  color: var(--text-primary);
}

.reports-page {
  padding: 24px;
  min-height: 100%;
  overflow-y: auto;
  background: #f7f8fa;
}

.reports-header {
  margin-bottom: 24px;
}

.reports-header h1,
.reports-page-wrapper > div > h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.reports-header p {
  margin-top: 6px;
  color: var(--text-secondary);
}

.reports-section {
  background: #ffffff;
  border-radius: var(--radius-lg);
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: var(--shadow-card);
  border: 1px solid var(--border-light);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.user-count {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* ==========================================================================
   Table — rounded card wrapper, comfortable cell padding so text has
   breathing room from every border.
   ========================================================================== */

.table-container {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  margin-top: 8px;
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
  font-size: 14px;
}

.reports-table th {
  padding: 16px 22px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background: var(--bg-subtle);
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-light);
  white-space: nowrap;
}

.reports-table th:first-child {
  border-top-left-radius: var(--radius-lg);
}

.reports-table th:last-child {
  border-top-right-radius: var(--radius-lg);
}

.reports-table td {
  padding: 16px 22px;
  font-size: 14px;
  color: var(--text-primary);
  border-bottom: 1px solid #f0f1f3;
  white-space: nowrap;
}

.reports-table tbody tr:last-child td {
  border-bottom: none;
}

.reports-table tbody tr:hover {
  background: var(--bg-subtle);
}

.selected-row {
  background: #eef5ff !important;
}

/* Row action button — pill shape, matches the brand's purple accent */
.view-report-button {
  border: 1.5px solid var(--accellor-purple-start);
  background: #fff;
  color: var(--accellor-purple-start);
  padding: 9px 20px;
  border-radius: var(--radius-pill);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.view-report-button:hover {
  background: var(--accellor-purple-start);
  color: #fff;
  box-shadow: var(--shadow-hover);
}

/* Status pills */
.status-badge {
  display: inline-block;
  padding: 5px 14px;
  border-radius: var(--radius-pill);
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
}

.status-completed {
  background: rgba(52, 179, 137, 0.12);
  color: #1d7a3f;
}

.status-started {
  background: rgba(79, 195, 217, 0.15);
  color: #996c00;
}

.status-default {
  background: #eeeeee;
  color: #555;
}

.loading-container,
.error-container,
.empty-container {
  padding: 40px 24px;
  text-align: center;
  color: var(--text-secondary);
}

.error-container {
  color: #c62828;
}

.assessment-section {
  margin-top: 24px;
}

.selected-user-header {
  margin-bottom: 20px;
}

.selected-user-header h2 {
  margin: 0 0 6px;
  font-weight: 700;
}

.selected-user-header p {
  margin: 0;
  color: var(--text-secondary);
}

.assessment-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  padding: 20px 22px;
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  background: var(--bg-subtle);
}

.summary-card span {
  display: block;
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 6px;
}

.summary-card strong {
  font-size: 22px;
  color: var(--text-primary);
}

.detailed-reports {
  margin-top: 28px;
}

.detailed-reports > h3 {
  margin-bottom: 16px;
}

.assessment-card {
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  margin-bottom: 18px;
  padding: 24px;
}

.assessment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-light);
}

.assessment-card-header h4 {
  margin: 0 0 5px;
  font-size: 17px;
  font-weight: 700;
}

.assessment-card-header span {
  color: var(--text-secondary);
  font-size: 13px;
}

.assessment-details-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.assessment-details-grid div,
.metrics-grid div {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.assessment-details-grid label,
.metrics-grid label {
  font-size: 11px;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.assessment-details-grid span,
.metrics-grid strong {
  font-size: 14px;
  color: var(--text-primary);
}

.report-subsection {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--border-light);
}

.report-subsection h4 {
  margin: 0 0 15px;
  font-size: 15px;
  font-weight: 700;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

@media (max-width: 1000px) {
  .assessment-details-grid,
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 650px) {
  .reports-page-wrapper {
    padding: 20px;
  }

  .reports-page {
    padding: 15px;
  }

  .assessment-summary {
    grid-template-columns: 1fr;
  }

  .assessment-details-grid,
  .metrics-grid {
    grid-template-columns: 1fr;
  }
}

/* ==========================================================================
   Assessment detail modal
   ========================================================================== */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(20, 20, 31, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
}

.modal-content {
  background: #fff;
  border-radius: var(--radius-lg);
  max-width: 760px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 32px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 6px 10px;
  border-radius: var(--radius-pill);
  transition: background 0.2s ease, color 0.2s ease;
}

.modal-close-button:hover {
  color: #000;
  background: var(--bg-subtle);
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/Reports.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;EACE,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;;EAE7B,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;;EAEpB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;;;+EAG+E;;AAE/E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;;+EAG+E;;AAE/E;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sEAAsE;AACtE;EACE,gDAAgD;EAChD,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uEAAuE;AACzE;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;;IAEE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B","sourcesContent":["/* ==========================================================================\n   Accellor AI Skill Assessment — Reports theme\n   Matches the main assessment landing page (logo/hero) design system.\n   ========================================================================== */\n\n:root {\n  --accellor-navy: #14141f;\n  --accellor-teal: #2dd4bf;\n  --accellor-teal-dark: #14b8a6;\n  --accellor-purple-start: #4b4f9e;\n  --accellor-purple-end: #6d8fd8;\n  --accellor-cyan-start: #4fc3d9;\n  --accellor-green-start: #34b389;\n  --accellor-red-start: #e0446b;\n\n  --text-primary: #14141f;\n  --text-secondary: #6b7280;\n  --border-light: #e5e7eb;\n  --bg-page: #ffffff;\n  --bg-subtle: #f8f9fb;\n\n  --radius-md: 10px;\n  --radius-lg: 16px;\n  --radius-pill: 999px;\n  --shadow-card: 0 4px 14px rgba(20, 20, 31, 0.06);\n  --shadow-hover: 0 8px 20px rgba(20, 20, 31, 0.1);\n}\n\n/* ==========================================================================\n   Page wrapper — generous outer padding so content never touches the\n   browser/sidebar edge.\n   ========================================================================== */\n\n.reports-page-wrapper {\n  padding: 40px 48px;\n  max-width: 1480px;\n  margin: 0 auto;\n  font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif;\n  color: var(--text-primary);\n}\n\n.reports-page {\n  padding: 24px;\n  min-height: 100%;\n  overflow-y: auto;\n  background: #f7f8fa;\n}\n\n.reports-header {\n  margin-bottom: 24px;\n}\n\n.reports-header h1,\n.reports-page-wrapper > div > h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\n.reports-header p {\n  margin-top: 6px;\n  color: var(--text-secondary);\n}\n\n.reports-section {\n  background: #ffffff;\n  border-radius: var(--radius-lg);\n  padding: 28px;\n  margin-bottom: 24px;\n  box-shadow: var(--shadow-card);\n  border: 1px solid var(--border-light);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.section-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.user-count {\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* ==========================================================================\n   Table — rounded card wrapper, comfortable cell padding so text has\n   breathing room from every border.\n   ========================================================================== */\n\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-card);\n  margin-top: 8px;\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 700px;\n  font-size: 14px;\n}\n\n.reports-table th {\n  padding: 16px 22px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-light);\n  white-space: nowrap;\n}\n\n.reports-table th:first-child {\n  border-top-left-radius: var(--radius-lg);\n}\n\n.reports-table th:last-child {\n  border-top-right-radius: var(--radius-lg);\n}\n\n.reports-table td {\n  padding: 16px 22px;\n  font-size: 14px;\n  color: var(--text-primary);\n  border-bottom: 1px solid #f0f1f3;\n  white-space: nowrap;\n}\n\n.reports-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.reports-table tbody tr:hover {\n  background: var(--bg-subtle);\n}\n\n.selected-row {\n  background: #eef5ff !important;\n}\n\n/* Row action button — pill shape, matches the brand's purple accent */\n.view-report-button {\n  border: 1.5px solid var(--accellor-purple-start);\n  background: #fff;\n  color: var(--accellor-purple-start);\n  padding: 9px 20px;\n  border-radius: var(--radius-pill);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.view-report-button:hover {\n  background: var(--accellor-purple-start);\n  color: #fff;\n  box-shadow: var(--shadow-hover);\n}\n\n/* Status pills */\n.status-badge {\n  display: inline-block;\n  padding: 5px 14px;\n  border-radius: var(--radius-pill);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.status-completed {\n  background: rgba(52, 179, 137, 0.12);\n  color: #1d7a3f;\n}\n\n.status-started {\n  background: rgba(79, 195, 217, 0.15);\n  color: #996c00;\n}\n\n.status-default {\n  background: #eeeeee;\n  color: #555;\n}\n\n.loading-container,\n.error-container,\n.empty-container {\n  padding: 40px 24px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.error-container {\n  color: #c62828;\n}\n\n.assessment-section {\n  margin-top: 24px;\n}\n\n.selected-user-header {\n  margin-bottom: 20px;\n}\n\n.selected-user-header h2 {\n  margin: 0 0 6px;\n  font-weight: 700;\n}\n\n.selected-user-header p {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.assessment-summary {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.summary-card {\n  padding: 20px 22px;\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  background: var(--bg-subtle);\n}\n\n.summary-card span {\n  display: block;\n  font-size: 12px;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n}\n\n.summary-card strong {\n  font-size: 22px;\n  color: var(--text-primary);\n}\n\n.detailed-reports {\n  margin-top: 28px;\n}\n\n.detailed-reports > h3 {\n  margin-bottom: 16px;\n}\n\n.assessment-card {\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  margin-bottom: 18px;\n  padding: 24px;\n}\n\n.assessment-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.assessment-card-header h4 {\n  margin: 0 0 5px;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.assessment-card-header span {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.assessment-details-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.assessment-details-grid div,\n.metrics-grid div {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.assessment-details-grid label,\n.metrics-grid label {\n  font-size: 11px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.assessment-details-grid span,\n.metrics-grid strong {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.report-subsection {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-light);\n}\n\n.report-subsection h4 {\n  margin: 0 0 15px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n@media (max-width: 1000px) {\n  .assessment-details-grid,\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 650px) {\n  .reports-page-wrapper {\n    padding: 20px;\n  }\n\n  .reports-page {\n    padding: 15px;\n  }\n\n  .assessment-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .assessment-details-grid,\n  .metrics-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ==========================================================================\n   Assessment detail modal\n   ========================================================================== */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(20, 20, 31, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n}\n\n.modal-content {\n  background: #fff;\n  border-radius: var(--radius-lg);\n  max-width: 760px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 32px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-secondary);\n  padding: 6px 10px;\n  border-radius: var(--radius-pill);\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.modal-close-button:hover {\n  color: #000;\n  background: var(--bg-subtle);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
